export enum LocalStorage {
  Token = 'userToken',
  Id = 'userId',
}
